export const buildCategories = [
  {
    title: "Student Platforms",
    icon: "S",
    description: "Focused tools for academic planning, resources, and campus-specific workflows."
  },
  {
    title: "AI Tools",
    icon: "A",
    description: "Useful AI layers for summarizing, organizing, drafting, and decision support."
  },
  {
    title: "Mobile Applications",
    icon: "M",
    description: "Lightweight apps designed around repeat use, speed, and daily utility."
  },
  {
    title: "Developer Tools",
    icon: "D",
    description: "Small technical products that make building, shipping, and debugging easier."
  },
  {
    title: "SaaS Products",
    icon: "P",
    description: "Narrow workflow platforms with clean UX and long-term operational leverage."
  }
];

export const initiatives = [
  { title: "Mobile Applications", status: "Building" },
  { title: "AI-powered Utilities", status: "Research" },
  { title: "Productivity Tools", status: "Coming Soon" },
  { title: "New Student Platforms", status: "Beta" }
];

export const timeline = [
  { title: "GradeVIT launched", detail: "First focused product released for VIT students." },
  { title: "First users onboarded", detail: "Early usage shaped the next set of utilities." },
  { title: "Technie ecosystem established", detail: "The umbrella studio identity became the product home." },
  { title: "New products in development", detail: "Mobile, AI, and productivity experiments are underway." }
];

export const metrics = [
  { label: "Monthly Users", value: 2500, suffix: "+" },
  { label: "Product Live", value: 1, suffix: "" },
  { label: "Products Planned", value: 4, suffix: "+" },
  { label: "Community", value: 1, suffix: " growing" }
];
